import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { UpdateDataFreshnessPolicyAction } from '~src/dataAcceleration/actions/UpdateDataFreshnessPolicyAction';
import { UpdateDataFreshnessPolicyHelper as UpdateDataFreshnessPolicyHelper } from '~src/dataAcceleration/components/UpdateDataFreshnessPolicyDialog';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { reloadSpaceIfUpdatingCurrentSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';
import { fetchDataFreshnessPolicyByWorkbookId, fetchWorkbookById } from '~src/workbook/sagas/WorkbookSagasHelper';

export function* updateDataFreshnessPolicySaga(action: UpdateDataFreshnessPolicyAction) {
    try {
      const workbookInfos = action.workbooks as IWorkbookInfo[];

      if (workbookInfos === undefined || workbookInfos.length === 0) {
        throw new Error(Messages.unexpectedError());
      }

      let workbookInfo = workbookInfos[0].workbookDataFreshness === undefined
                            ? yield call(fetchWorkbookById, workbookInfos[0].id) : workbookInfos[0];
      if (workbookInfo.workbookDataFreshness === undefined){
        workbookInfo.workbookDataFreshness = (yield call(fetchDataFreshnessPolicyByWorkbookId, workbookInfos[0].id)).workbookDataFreshness;
      }
      // errors are handled by the dialog - nothing to be done on success
      const result = yield call(openUpdateDataFreshnessPolicyDialog, workbookInfo);

      const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, action.workbooks);
      if (!maybeReloaded) {
        yield put(requestSpaceContents());
      }

    } catch(e) {
      yield put(requestFailed(e, Messages.unexpectedError()));
    }
  }

function openUpdateDataFreshnessPolicyDialog(workbook: IWorkbookInfo): Promise<any> {
    return UpdateDataFreshnessPolicyHelper.confirmUpdateDataFreshnessPolicy(workbook);
  }
